<template>
  <div class="one-page__container">
    <div class="one-page__top-nav">
      <slot name="top"></slot>
    </div>

    <div class="one-page__bottom-nav">

      <div
        class="one-page__bottom-nav--left"
        v-show="show_bottom_left"
      >
        <slot name="bottom-left"></slot>
      </div>
      <div class="one-page__bottom-nav--right one-page__table">
        <slot name="bottom-right"></slot>
      </div>
    </div>

    <slot name="default"></slot>
  </div>
</template>

<script>
export default {
  name: 'OnePageContainer',

  props: {
    show_bottom_left: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.app-wrapper > div > div > div:not(.v-overlay__content) {
  height: auto;
}

.one-page {
  &__container {
    padding: 16px 12px 22px;
    height: calc(100vh - 60px);
    display: flex;
    flex-direction: column;
  }

  /* Top navigation for Table */
  &__top-nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;

    &--right {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .v-input {
      max-width: 360px;
    }

    .v-btn::v-deep {
      border-radius: 2px;
      border: 1px solid var(--v-gray-base) !important;
    }

    .v-select {
      max-width: 134px;
      font-size: 14px;
    }
  }

  /* Filters and Table */
  &__bottom-nav {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex: 1;

    &--left {
      min-width: 216px;
      max-width: 216px;
      width: 216px;
      padding-left: 8px;
      padding-right: 8px;
      height: 100%;
    }

    &--right {
      padding-left: 8px;
      padding-right: 8px;
      flex: 1;
      height: 100%;
      width: calc(100% - 216px);
      position: relative;

      .table-descr {
        position: absolute;
        top: -20px;
        left: 10px;
      }
    }
  }
}

/* end Top navigation for Table */

.one-page__table {
  display: flex;
  flex-direction: column;
}
</style>